document.addEventListener('click', function (e) {

    const btnAbrir = e.target.closest('#modalProduccionInyeccion #btnAgregarProduccionInyeccion');

    if (btnAbrir) {
        const modalPadre = document.querySelector('#modalProduccionInyeccion');
        const idEncabezado = modalPadre.querySelector('#idReporteInyeccion').value;
        const modalHijo = document.querySelector('#modalAgregarProduccionInyeccion');        

        if (!idEncabezado || !modalHijo){
            console.error("No se encontró el ID del encabezado o el modal hijo.");
            window.location.reload();
            return;
        }

        const inputIdEncabezado = modalHijo.querySelector('#idEncabezadoReporteInyeccion');

        if (!inputIdEncabezado) {
            console.error("No se encontró el input para el ID del encabezado en el modal hijo.");
            window.location.reload();
            return;
        }
        inputIdEncabezado.value = idEncabezado;
    }
});